exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#admin_channel_groupings_page .table-responsive {\n  overflow: inherit !important;\n}\n#admin_channel_groupings_page .table-responsive .VueTables__table {\n  table-layout: fixed;\n  overflow: inherit !important;\n}\n#admin_channel_groupings_page .VueTables__search {\n  display: none;\n}\n#admin_channel_groupings_page .VuePagination {\n  display: none;\n}\n#admin_channel_groupings_page .v-select {\n  width: 25rem;\n}", ""]);

// exports
